
import { Options, Vue } from "vue-class-component";

@Options({
  name: "CoachView",
})
export default class CoachView extends Vue {}
